<template>
  <main-layout class="batch-print" page-title="打印记录明细">
    <div slot="main-content" class="main-content">
      <div class="page">
        <div class="detailInfo">
          <div class="info-item">
            <span>打印方式：</span
            >{{ $route.query.taskType === "1" ? "本地打印" : "远程打印" }}
          </div>
          <div class="info-item">
            <span>当前队列号：</span
            >{{ $route.query.taskType === "1" ? "--" : $route.query.queueNo }}
          </div>
          <div class="info-item">
            <span>批次号：</span>{{ $route.query.taskBatchId }}
          </div>
          <div class="info-item">
            <span>当前进度：</span
            >{{
              $route.query.taskType === "1"
                ? "--"
                : $route.query.finishTaskNum + "/" + $route.query.totalTaskNum
            }}
          </div>
          <div class="info-item" style="flex: none">
            <span>操作时间：</span>{{ $route.query.createTime }}
          </div>
        </div>
        <div class="page-header">
          <el-date-picker
            v-model="queryParams.dateArry"
            size="medium"
            type="daterange"
            clearable
            :picker-options="pickerDateOptions"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开具开始"
            end-placeholder="开具结束"
            @change="handleChange"
          >
          </el-date-picker>
          <el-select
            v-model="queryParams.origin"
            size="medium"
            @change="handleChange"
          >
            <el-option label="全部合格证类型" :value="null"></el-option>
            <el-option
              v-for="(value, key) in certificate_type"
              :key="key"
              :label="value"
              :value="key"
            />
          </el-select>
          <el-input
            v-model.trim="queryParams.certificateNo"
            size="medium"
            placeholder="搜索合格证编号"
            prefix-icon="el-icon-search"
            @input="handleChangeDebounce"
          />
        </div>
        <el-table
          v-if="!isShowEmpty"
          ref="multipleTable"
          class="page-table"
          empty-text=" "
          v-loading="tableLoading"
          :data="certificateList"
          stripe
          height="calc(100vh - 328px)"
          :row-class-name="TableRow"
          :header-cell-style="{ color: '#64C3A4', fontSize: '16px' }"
          :cell-style="{ color: '#666666' }"
        >
          <el-table-column label="打印状态" width="100" prop="taskDetailStatus">
            <template slot-scope="scope">
              {{ printStatus(scope.row.taskDetailStatus) }}
            </template>
          </el-table-column>
          <el-table-column label="操作时间" prop="createTime" />
          <el-table-column
            label="合格证编号"
            prop="certificateNo"
            width="180"
          />
          <el-table-column label="产品名称" prop="productName" />
          <el-table-column label="数量（重量）" prop="farmName">
            <template slot-scope="scope">
              {{ scope.row.productNum + scope.row.productUnit }}
            </template>
          </el-table-column>
          <el-table-column
            label="操作人手机号"
            width="130"
            prop="operatorPhoneNumber"
          />
          <el-table-column
            label="合格证类型"
            width="110"
            prop="certificateTemplateType"
          >
            <template slot-scope="scope">
              {{ certificate_type[scope.row.origin].replaceAll("合格证", "")
              }}{{
                scope.row.certificateTemplateType === 0
                  ? "-普通"
                  : scope.row.certificateTemplateType === 1
                  ? "-绿色"
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column label="合格开具时间" width="130" prop="issueDate" />
        </el-table>
        <div class="noDataImg" v-else>
          <div class="imgNo">
            <img
              src="@/assets/images/aviatFarmingList/batch-nodata.png"
              alt=""
            />
          </div>
          <p style="color: #333; margin-bottom: 20px">未搜索到相关合格证</p>
        </div>
        <el-pagination
          v-if="!isShowEmpty"
          :total="total"
          background
          :current-page="queryParams.pageNo"
          :page-size="queryParams.pageSize"
          @current-change="currentChange"
          @size-change="sizePageChange"
          layout="sizes, total, prev, pager, next"
          v-show="!!certificateList.length"
        />
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/MainLayout";
import {
  getCertificateDetail,
  getPageTaskDetail,
} from "@/api/request/snkd.produce";
// import sameIn from "@/mixins/listsdetails";
import { certificate_type } from "@/confing/map_tab";
import { debounce } from "@/utils";
import { mapActions } from "vuex";

export default {
  name: "batchPrint",
  // mixins: [sameIn],
  components: {
    MainLayout,
  },
  data() {
    return {
      certificate_type,
      certificateList: [],
      selectList: [],
      queryParams: {
        pageNo: 1,
        pageSize: 10,
        certificateNo: "",
        origin: null,
        productName: "",
        printStatus: "",
        dateArry: [],
      },
      pickerDateOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      total: 0,
      tableLoading: false,
      isShowEmpty: false,
      dialogVisible: false,
      selectCertificate: {},
      isPrint: false,
    };
  },
  computed: {
    isGreenCertificate() {
      const key = this.selectCertificate.certificateTemplate?.templateKey;
      return ["dclshgz1", "dclshgz2"].includes(key);
    },
    isAllSelect() {
      return this.selectList.length === this.certificateList.length;
    },
    isIndeterminate() {
      return (
        this.selectList.length > 0 &&
        this.selectList.length < this.certificateList.length
      );
    },
  },
  created() {
    this.getList();
    this.isPrint = this.hasPermission("produce:certificate:print");
  },
  methods: {
    ...mapActions("permission", ["hasPermission"]),
    getList() {
      this.tableLoading = true;
      const params = {
        ...this.queryParams,
        printStatus: 1,
        taskBatchId: this.$route.query.taskBatchId,
      };
      if (this.queryParams.dateArry) {
        params["startDate"] = this.queryParams.dateArry[0] || "";
        params["endDate"] = this.queryParams.dateArry[1] || "";
      }
      getPageTaskDetail(params).then(({ obj }) => {
        this.tableLoading = false;
        this.certificateList = obj ? obj.list : [];
        this.total = obj.totalCount;
        this.isShowEmpty = !this.certificateList.length;
      });
    },
    //设置表格行的样式
    TableRow({ rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "statistics-warning-row";
      } else {
        return "";
      }
    },
    // 输入框input 防抖
    handleChangeDebounce: debounce(async function () {
      this.queryParams.pageNo = 1;
      await this.getList();
    }),
    // 选择日期类型 chang方法
    handleChange() {
      this.queryParams.pageNo = 1;
      this.getList();
    },
    // 查看按钮
    checkInfo(row) {
      const { certificateId, certificateNo } = row;
      getCertificateDetail({ certificateId, certificateNo }).then((res) => {
        this.selectCertificate = res.obj;
        this.dialogVisible = true;
      });
    },
    printCertificate(row) {
      if (!this.isPrint) {
        this.$message({
          type: "info",
          message: "您的权限无法使用该功能，可联系超级管理员修改权限",
        });
        return false;
      }
      const { certificateId, certificateNo } = row;
      getCertificateDetail({ certificateId, certificateNo }).then((res) => {
        const { certificateTemplate } = res.obj;
        const key = certificateTemplate.templateKey;
        const componentId = ["dclshgz1", "dclshgz2"].includes(key)
          ? "GreenCertificateTemplate"
          : "CertificateTemplate";
        console.log(componentId);
        this.$print({
          list: [res.obj, res.obj, res.obj],
        });
        // this.$nextTick(() => {
        //   printJS({
        //     printable: "print-hgz", // 'printFrom', // 标签元素id
        //     type: "html",
        //     style: "@page {margin:0};",
        //   });
        // });
      });
    },
    // 单选
    handleSelectionChange(rows) {
      this.selectList = rows;
    },
    // 全选按钮操作
    allSelectTable() {
      this.$refs.multipleTable.toggleAllSelection();
    },
    // 页码单选
    currentChange(page) {
      this.queryParams.pageNo = page;
      this.getList();
    },
    // 分页数量
    sizePageChange(pages) {
      this.queryParams.pageNo = 1;
      this.queryParams.pageSize = pages;
      this.getList();
    },
    printStatus(status) {
      if (this.$route.query.taskType === "1") {
        return "打印成功";
      }
      if (status === -1 || status === -2) {
        return "打印失败";
      }
      if (status === 0 || status === 1) {
        return "打印中";
      }
      if (status === 2) {
        return "打印成功";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.batch-print {
  .main-content {
    width: 1200px;
    height: 100%;
    background: #fff;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    .page {
      min-height: 0;
      flex: 1;
      padding: 20px;
      .detailInfo {
        background-color: #f7f9fb;
        padding: 15px;
        display: flex;
        margin-bottom: 20px;
        align-items: center;
        .info-item {
          flex: 1;
          height: 72px;
          background-color: #fff;
          padding: 10px 20px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          span {
            color: #64c3a4;
            font-weight: 700;
          }
        }
      }
      &-header {
        display: flex;
        & > div {
          width: 190px;
          margin-right: 10px;
        }
        .right-btn {
          margin-left: auto;
          margin-right: 0;
          width: auto;
        }
        ::v-deep .el-date-editor--daterange {
          width: 250px;
        }
      }
      &-table {
        margin-top: 10px;
        ::v-deep .hidden-label {
          opacity: 0;
        }
        .produce-box {
          display: flex;
          align-items: center;
          .produceImg {
            width: 35px;
            height: 35px;
            margin-right: 10px;
          }
        }
        ::v-deep .el-checkbox__inner {
          width: 21px;
          height: 21px;
          border-radius: 50%;
          &::after {
            width: 4.5px;
            height: 10.5px;
            top: 1.5px;
            left: 6px;
            border-width: 1.5px;
          }
          &::before {
            height: 3px;
            top: 8.5px;
          }
        }
      }
      ::v-deep .el-pagination {
        text-align: right;
        margin-top: 10px;
      }
      ::v-deep .el-table td,
      ::v-deep .el-table th.is-leaf {
        border: none;
      }
    }
    .fixed-bottom {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #fff;
      padding: 18px 30px;
      box-sizing: border-box;
      box-shadow: 0px -4px 20px 0px rgba(0, 0, 0, 0.04);
      z-index: 1;
      .select-box {
        cursor: pointer;
        outline: 0;
        line-height: 1;
        vertical-align: middle;
        display: flex;
        align-items: center;
        &.is-indeterminate {
          .selectAll {
            background-color: #64c3a4;
            border-color: #64c3a4;
            &::before {
              content: "";
              position: absolute;
              display: block;
              background-color: #fff;
              height: 3px;
              transform: scale(0.5);
              left: 0;
              right: 0;
              top: 8.5px;
            }
          }
        }
        &.is-select {
          .selectAll {
            background-color: #64c3a4;
            border-color: #64c3a4;
            &::after {
              transform: rotate(45deg) scaleY(1);
            }
          }
        }
        .selectAll {
          width: 21px;
          height: 21px;
          border-radius: 50%;
          display: inline-block;
          position: relative;
          border: 1px solid #dcdfe6;
          box-sizing: border-box;
          background-color: #fff;
          z-index: 1;
          margin-right: 10px;
          transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
            background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
          &::after {
            box-sizing: content-box;
            content: "";
            border: 1.5px solid #ffffff;
            border-left: 0;
            border-top: 0;
            height: 10.5px;
            left: 6px;
            position: absolute;
            top: 1.5px;
            transform: rotate(45deg) scaleY(0);
            width: 4.5px;
            transition: transform 0.15s ease-in 0.05s;
            transform-origin: center;
          }
        }
      }
    }
  }
}
</style>
